import type { HTMLAttributes } from "react";

export default function AuthorIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.93765 3.68928C7.93765 5.23289 6.68626 6.48428 5.14265 6.48428C3.59905 6.48428 2.34766 5.23289 2.34766 3.68928C2.34766 2.14568 3.59905 0.894287 5.14265 0.894287C6.68626 0.894287 7.93765 2.14568 7.93765 3.68928Z"
        fill="currentColor"
      />
      <path
        d="M8.79027 8.01598C8.45861 7.68432 8.06384 7.44751 7.62172 7.28955C6.9269 7.77904 6.05841 8.06333 5.14252 8.06333C4.22662 8.06333 3.37398 7.77915 2.66331 7.28955C1.40002 7.73169 0.5 8.916 0.5 10.3214L0.50011 11.9321C0.50011 12.2479 0.768539 12.5163 1.08434 12.5163H7.81121C7.59014 11.8215 7.55853 10.8898 7.98491 9.67396C8.20609 9.1056 8.47451 8.56863 8.7903 8.01601L8.79027 8.01598Z"
        fill="currentColor"
      />
      <path
        d="M15.3748 3.02607C15.1222 2.89973 13.7326 3.98931 12.3114 5.52101C12.2957 5.53676 12.2798 5.55262 12.2798 5.58413L11.7903 8.12644L11.4113 6.83154C11.3797 6.75257 11.2692 6.72095 11.2219 6.79993C10.7797 7.35266 10.3692 7.92113 10.0218 8.4896C10.006 8.50535 10.006 8.53696 10.006 8.56857L10.3534 11.174L9.45331 10.0213C9.40594 9.95818 9.29535 9.97393 9.26385 10.0529C8.82171 11.2372 8.82171 12.2952 9.65862 12.99L8.5533 14.8059C8.47432 14.948 8.56905 15.1059 8.727 15.1059H9.64287C9.73759 15.1059 9.81657 15.0428 9.83232 14.948C9.89544 14.6638 10.0691 14.0163 10.3377 13.3847C11.7903 13.9375 12.9589 12.7216 13.7959 10.9372C13.8275 10.8582 13.7642 10.7635 13.6853 10.7792L12.2325 10.9845L14.459 9.216C14.4748 9.20025 14.4907 9.18439 14.4907 9.16864C14.7117 8.47381 14.9012 7.74752 15.0591 7.06846C15.0749 6.98949 15.0118 6.92637 14.9328 6.94212L13.3695 7.24217L15.2959 5.59999C15.3117 5.58424 15.3276 5.55263 15.3276 5.53688C15.5486 4.14726 15.5486 3.12078 15.3749 3.02606L15.3748 3.02607Z"
        fill="currentColor"
      />
    </svg>
  );
}
